<template>
  <div class="max-width-4 mt3 mx-auto content-wrapper clearfix">
    <div class="md-col-8 sm-col-12 pr1 mx-auto clearfix">
      <div class="col-12">
        <div class="partners">
          <h3 class="h2 headline">Kooperationspartner</h3>

          <div class="clearfix mt3">
            <div class="partner-wrapper">
              <div class="partner-item">
                <img class="image" src="../assets/partners/rechtspsychologie-kooperationspartner.png" alt="Zentrum für Rechtspsychologie" title="Zentrum für Rechtspsychologie">
              </div>
              <div class="partner-item">
                <a class="text-decoration-none" target="_blank" href="https://fit2work.at/?utm_source=harald_parrainer" title="Fit2Work - Kooperationspartner" rel="noopener noreferrer">
                  <span class="hide">Fit2Work</span>
                  <img class="image" src="../assets/partners/fit2work-kooperationspartner.png" alt="Fit2Work" title="Fit2Work">
                </a>
              </div>
              <div class="partner-item">
                <a class="text-decoration-none" target="_blank" href="https://www.bundesheer.at/?utm_source=harald_parrainer" title="Bundesheer- Kooperationspartner" rel="noopener noreferrer">
                  <span class="hide">Bundesheer</span>
                  <img class="image" src="../assets/partners/bundesheer-kooperationspartner.png" alt="Bundesheer" title="Bundesheer">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app-partners'
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

.partners {
  padding-top: 1rem;
  padding-bottom: 1rem;

  .headline {
    color: #293133;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: bold;
    font-family: $headline-font;
  }

  .partner-wrapper {
    display: flex;

    .partner-item {
      flex-grow: 1;
      justify-content: center;
      vertical-align: middle;
      text-align: center;

      a {
        color: white;
        border-bottom: 0px;
        box-shadow: none;
      }

      .image {
        width: 8rem;
        height: auto;
      }
    }
  }

  @media screen and (max-width: $break-md) {
    .partner-wrapper {
      display: block;

      .partner-item {
        display: block;
        text-align: center;

        &:not(:first-child) {
          margin-top: 2rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partners.vue